<template>
  <div class="home">
    <Dashboard/>
  </div>
</template>

<script>
import Dashboard from '../modules/dashboard/Index';

export default {
  name: 'home',
  components: {
    Dashboard,
  },
};
</script>
